export default {
  NAV_FINISHED_STEPS: 'stader fullført',
  ARENA_WHERE_YOU_GO: 'Kvar vil du?',
}
